import { render, staticRenderFns } from "./BasicLaw.vue?vue&type=template&id=1f10cb75&"
import script from "./BasicLaw.vue?vue&type=script&lang=js&"
export * from "./BasicLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports